import { Brain, MessageCircle, Clock, Bot } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { WaitlistDialog } from "@/components/WaitlistDialog";

const ITEM_KEYS = [
  { icon: Brain, key: "aiagent.c1" },
  { icon: MessageCircle, key: "aiagent.c2" },
  { icon: Clock, key: "aiagent.c3" },
];

export function AiAgentSection() {
  const { t } = useI18n();
  return (
    <section
      className="py-24 px-6 relative overflow-hidden"
      style={{ backgroundColor: "#0c1d50" }}
    >
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 50% 0%, rgba(232,114,26,0.10), transparent 60%)",
        }}
      />
      <div className="relative max-w-6xl mx-auto text-center">
        <span
          className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-6"
          style={{ backgroundColor: "#e8721a", color: "#ffffff" }}
        >
          <Bot size={14} /> {t("aiagent.badge")}
        </span>
        <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-3 text-white">
          {t("aiagent.title")}
        </h2>
        <p className="text-3xl md:text-4xl font-bold tracking-tight mb-6 text-gradient-orange">
          {t("aiagent.subtitle")}
        </p>
        <p
          className="text-base md:text-lg max-w-3xl mx-auto mb-14 leading-relaxed"
          style={{ color: "#94a3b8" }}
        >
          {t("aiagent.desc")}
        </p>

        <div className="grid md:grid-cols-3 gap-5 mb-12 text-left">
          {ITEM_KEYS.map(({ icon: Icon, key }) => (
            <div
              key={key}
              className="p-7 rounded-3xl"
              style={{ backgroundColor: "#0e2058", border: "1px solid rgba(255,255,255,0.08)" }}
            >
              <div
                className="w-12 h-12 rounded-2xl flex items-center justify-center mb-5"
                style={{ backgroundColor: "rgba(232,114,26,0.12)" }}
              >
                <Icon className="w-6 h-6" style={{ color: "#e8721a" }} />
              </div>
              <h3 className="text-lg font-bold mb-2 text-white">{t(`${key}.title`)}</h3>
              <p className="text-sm leading-relaxed" style={{ color: "#94a3b8" }}>
                {t(`${key}.desc`)}
              </p>
            </div>
          ))}
        </div>

        <WaitlistDialog>
          <button
            type="button"
            style={{
              backgroundColor: "#e8721a",
              boxShadow: "0 0 40px rgba(232,114,26,0.55)",
            }}
            className="inline-flex items-center justify-center rounded-full px-8 py-3.5 text-base font-semibold text-white hover:brightness-110 transition"
          >
            {t("aiagent.cta")}
          </button>
        </WaitlistDialog>
      </div>
    </section>
  );
}
